export default __webpack_public_path__ + "static/media/Rectangle 39.cc6fe32c.svg";